// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, addToStartOfChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    DispatchCompleteChangeQty,
} from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/ChangeProductQty";

const startUpdatingQty: typeof DispatchCompleteChangeQty = props => {
    props.dispatch({
        type: "xQuickOrder/update",
        isAddingToCart: true,
    } as any);
};

const finishtUpdatingQty: typeof DispatchCompleteChangeQty = props => {
    props.dispatch({
        type: "xQuickOrder/update",
        isAddingToCart: false,
    } as any);
};

addToStartOfChain(chain, startUpdatingQty);
addToEndOfChain(chain, finishtUpdatingQty);
